// extracted by mini-css-extract-plugin
export default {"task_list":"kanban-column_task_list__977nZ","kanbanScroller":"kanban-column_kanbanScroller__bEJmo"};